// extracted by mini-css-extract-plugin
module.exports = {"Columns":"Columns_Columns__I2_m2","Column":"Columns_Column__1v5C6","Line":"Columns_Line__3cmTt","Main":"Columns_Main__3axqH","Description":"Columns_Description__3D9vk"};